import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "app-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "header"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Navbar = _resolveComponent("Navbar");
  const _component_router_view = _resolveComponent("router-view");
  const _component_PageFooter = _resolveComponent("PageFooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [$options.showFooter ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Navbar, {
    hasScroll: $data.hasScroll
  }, null, 8, ["hasScroll"])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "m_content",
    ref: "content",
    onScroll: _cache[0] || (_cache[0] = $event => $options.contentScroll($event))
  }, [_createVNode(_component_router_view), $options.showFooter ? (_openBlock(), _createBlock(_component_PageFooter, {
    key: 0
  })) : _createCommentVNode("", true)], 544)])]);
}